<template>
  <div class="contact-us full-screen">
        <!-- content -->
        <div class="wrapper wrapper-full-page section content bg-image">
            <div>
                <div class="container">
                    <div class="text-center"><img class="mb-2 mt-5" src="@/assets/img/election_logo.png" alt="MUIC"></div>
                    <h5 class="font-weight-bold mt-3"><i class="fa fa-user-circle-o mr-2"></i>{{ $keycloak.fullName }}</h5>
                    <h5 class="text-capitalize font-en-chk font-weight-bold mt-2 mb-3">
                        <i class="fa fa-map-marker mr-2" aria-hidden="true"></i>Location : {{ detailDataToken.location }}
                        <!-- <p class="mt-0 mb-0">Building : {{ detailDataToken.building }}</p> -->
                    </h5>
                    <div align="center" class="mt-5" v-if="BtnCheckPoint">
                        <h6 class="mt-2 mb-3 text-capitalize text-muted font-en-chk font-weight-bold">
                            Press a button to <span class="text-success">check in</span> or <span class="text-danger">check out</span>.
                        </h6>
                        <b-card @click="checkPoint('in')" class="text-center card-in">
                            <b-card-text>
                                <img src="@/assets/img/in.png" class="mb-0 mt-2" width="64" alt="MUIC">
                                <hr class="mt-0 mb-0">
                                <h3 class="text-success mt-0 mb-2 font-en-chk font-weight-bold align-middle">IN</h3>
                            </b-card-text>
                        </b-card>
                        <b-card  @click="checkPoint('out')" class="text-center card-out">
                            <img src="@/assets/img/out.png" class="mb-0 mt-2" width="64" alt="MUIC">
                            <hr class="mt-0 mb-0">
                            <h3 class="text-danger mt-2 mb-2 font-en-chk font-weight-bold align-middle">OUT</h3>
                        </b-card>
                    </div>
                    <div v-else>
                        <b-alert class="mt-2 mb-0 font-en" show variant="success">
                            <h3 class="font-weight-bold mt-2 mb-1 font-en-chk text-success">
                                <i class="fa fa-check mr-2" aria-hidden="true"></i>Check point success 
                            </h3>
                            <hr class="mb-2 mt-1">
                        </b-alert>
                        <hr>
                        <!-- แบบประเมินความเสี่ยง -->
                        <!--  
                            <div v-if="dataRiskConsent !== ''">
                                <b-alert 
                                    class="mt-2" 
                                    show 
                                    :variant="dataRiskConsent === 'pass' ? 'success' : dataRiskConsent === 'reject' ? 'danger-cus' :  dataRiskConsent === 'not_found' ? 'warning' : ''"
                                >
                                    <h5 class="text-dark font-en-chk font-weight-bold mb-1">Nakhon Pathom's Self-Screening Form</h5>
                                    <hr class="mt-0 mb-0">
                                    <h5 class="text-dark font-en-chk mt-0 mb-1">
                                        <div v-if="dataRiskConsent === 'pass'">
                                            <i class="fa fa-check fa-lg mr-2" aria-hidden="true" />Pass.
                                        </div>
                                        <div v-if="dataRiskConsent === 'reject'">
                                            <i class="fa fa-times fa-lg mr-2" aria-hidden="true" />Not Pass.
                                        </div>
                                        <div v-if="dataRiskConsent === 'not_found'">
                                            <i class="fa fa-info fa-lg mr-2" aria-hidden="true" />Not Found.
                                        </div>
                                    </h5>
                                </b-alert>
                            </div>
                        -->
                        <!-- Blacklist -->
                            <div v-if="dataBlacklist.length !== 0">
                                <b-alert show variant="danger" class="text-center">
                                    <h3 class="font-thai mt-2 mb-3">You are in the risk group, you are not allowed to enter the premises.</h3>
                                    <hr>
                                    <h4 class="font-thai mt-3 mb-2">ท่านอยู่ในกลุ่มเสี่ยงไม่อนุญาติให้เข้าสถานที่</h4>
                                    <hr>
                                    <h3 class="font-thai mt-2 mb-2">โปรดติดต่อ : เจ้าหน้าที่ที่เกี่ยวข้อง / คณะทำงาน คปอ.</h3>
                                </b-alert>
                            </div>
                            <div v-else>
                            <!-- ATK PASS -->
                                <div v-if="dataAtk !== ''">
                                    <b-alert 
                                        class="mt-2" 
                                        show 
                                        :variant="diffExpirseDate(dataAtkExpirse) ? dataAtk === 'negative' ? 'success' : dataAtk === 'positive' ? 'danger' :  dataAtk === 'not_found' ? 'danger' : '' : 'danger'"
                                    >
                                        <h5 class="text-dark font-en-chk font-weight-bold mb-1">Antigen test kit [ ATK ]</h5>
                                        <hr class="mt-0 mb-0">
                                        <h5 v-if="diffExpirseDate(dataAtkExpirse)" class="text-dark font-en-chk mt-0 mb-1">
                                            <div v-if="dataAtk === 'negative'">
                                                <i class="fa fa-check fa-lg mr-2" aria-hidden="true" />
                                                Valid until ( {{ moment(moment(dataAtkExpirse).format('YYYY-MM-DD')).add(7, "days") .format("DD-MM-YYYY") }} ) 
                                            </div>
                                            <div v-if="dataAtk === 'positive'">
                                                <i class="fa fa-times fa-lg mr-2" aria-hidden="true" />Positive.
                                            </div>
                                            <div v-if="dataAtk === 'not_found'">
                                                <i class="fa fa-info fa-lg mr-2" aria-hidden="true" />Not Found.
                                            </div>
                                        </h5>
                                        <h5 v-else class="text-dark font-en-chk mt-0 mb-1">
                                            Your ATK result has expired.
                                        </h5>
                                    </b-alert>
                                </div>
                            <!-- VACCINE PASS -->
                                <div v-if="datavacineStatus !== ''">
                                    <b-alert 
                                        class="mt-2" 
                                        show 
                                        :variant="datavacineStatus === `You're fully vaccinated.` ? 'success' : 'danger'"
                                    >
                                        <h5 class="text-dark font-en-chk font-weight-bold mb-1">COVID-19 vaccination status</h5>
                                        <hr class="mt-0 mb-0">
                                        <h5 class="text-dark font-en-chk mt-0 mb-1">
                                            <div v-if="datavacineStatus === 'not_found' || datavacineStatus === 'not_success'">
                                                <i class="fa fa-info fa-lg mr-2" aria-hidden="true" />Not Found.
                                            </div>
                                            <div v-else>
                                                {{ datavacineStatus }}
                                            </div>
                                        </h5>
                                    </b-alert>
                                </div>
                            </div>
                        <hr>
                        <h6 class="text-muted text capitalize">History check Point</h6>
                        <b-list-group class="mt-2 mb-5">
                            <b-list-group-item class="leftBorderCustom mb-0 mt-0 font-en-chk rightBorderCustom" v-for="(check, index) in qrHistory" :key="index">
                                <p class="font-weight-bold font-en-chk mb-0 mt-0">{{ check.c1 }}</p>
                                <small class="font-en-chk mb-0 mt-0">Building : {{ check.c5 }}</small><br>
                                <small class="font-en-chk mb-0 mt-0"><i class="fa fa-history" aria-hidden="true"></i>{{ check.c2 }}</small>
                                <br>
                                <small class="font-en-chk mb-0 mt-0"><i class="fa fa-tags" aria-hidden="true"></i>{{ check.c4 === 'QR' ? 'QR CODE' : 'KIOSK' }}</small>
                                <br>
                                <small class="font-en-chk mb-0 mt-0">
                                    <i class="fa fa-lg" :class="{'fa-sign-in text-success' : check.cx === 'in' , 'fa-sign-out text-danger' : check.cx === 'out'}" aria-hidden="true"></i>
                                    {{ check.cx === 'in' ? 'IN' : 'OUT' }}
                                </small>
                            </b-list-group-item>
                        </b-list-group>
                        <br>
                    </div>
                </div>
            </div>
        </div>
        <!-- content -->
    </div>
</template>

<style lang="scss" scoped>
    .alert-success {
        background-color: #aee6d1;
        color: #000000;
    }
    .font-en-chk{ font-family: 'Rubik', sans-serif; font-weight: 300; }
    .leftBorderCustom{ border-left: 2px solid #9bccb9; }
    .rightBorderCustom{ border-right: 2px solid #9bccb9; }
    .btn-shadow-custom{ box-shadow: 5px 10px 18px #888888; }
    .alert-dark {
        color: #1b1e21;
        background-color: #f6f1fb;
        border-color: #c6c8ca;
    }
    .alert-danger-cus {
        color: #1b1e21;
        background-color: #ff8c8c;
        border-color: #c6c8ca;
    }
    .card-in{
        border: 1px solid #28a745;
        box-shadow: 5px 10px 18px #888888;
        width: 10rem;
        height: 10rem;
    }
    .card-out{
        border: 1px solid #dc3545;
        box-shadow: 5px 10px 18px #888888;
        width: 10rem;
        height: 10rem;
    }
    .bg-image {
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        background-image: url("../../assets/img/bg-election.png");
    }
</style>

<script>
  export default {
        data() {
            return {
                qrHistory:[],
                detailDataToken:[],
                BtnCheckPoint:true,
                dataRiskConsent:'',
                dataAtk: '',
                dataAtkExpirse: '',
                datavacineStatus: '',
                dataBlacklist: [],
            }
        },
        mounted(){
            this.callTokenDetail()
            // this.checkPoint()
        },
        computed: {
            getTokenUrl(){
                return typeof(this.$route.query.token) === "undefined" || this.$route.query.token === "" ?  this.$router.push("/notfound").catch(err => {}) : this.$route.query.token
            },
            // getPosition(){
            //     return typeof(this.$route.query.position) === "undefined" || this.$route.query.position === "" ?  this.$router.push("/foundpage").catch(err => {}) : this.$route.query.position
            // },
            // getType(){ return this.$route.query.type === "out" ?  'out' : 'in' },
        },
        methods: {
            async callTokenDetail(){
                try {
                    const res = await this.$http.get(`/checkcovid19/location/?token=${this.getTokenUrl}`)
                    this.detailDataToken = res.data
                } catch (error) {}
            },
            diffExpirseDate(testDate) {
                let formatTestDate = this.moment(testDate).format("YYYY-MM-DD");
                let weekLimit = this.moment(formatTestDate)
                    .add(7, "days")
                    .format("YYYY-MM-DD");
                let todayNow = this.moment().format("YYYY-MM-DD");
                if (this.moment(weekLimit).isBefore(todayNow)) {
                    return false;
                } else {
                    return true;
                }
            },
            async checkPoint(typeCheck) {
                this.dataRiskConsent = ''
                this.dataBlacklist = []
                // call api
                    try {
                        this.qrHistory = []
                        const res = await this.$http.get(`/checkcovid19/QR/?token=${this.getTokenUrl}&type_checkin=${typeCheck}`)
                        if(res.status === 200){
                            // check survey risk
                                // try {
                                //     const res_survey = await this.$http.get(`/checkcovid19/survey/${res.data[0].staff_id}/check/`)
                                //     if(res_survey.status === 200){
                                //         this.dataRiskConsent = res_survey.data.status
                                //     }else if(res_survey.status === 204){
                                //          this.dataRiskConsent = 'not_found'
                                //     }else{
                                //         throw { res_survey }
                                //     }
                                // } catch (error) {
                                //     this.dataRiskConsent = 'not_success'
                                // }
                            // check survey risk
                            // ATK PASS
                                try {
                                    const res_Atk = await this.$http.get(`/checkcovid19/atk/${res.data[0].staff_id}/check/`)
                                    if(res_Atk.status === 200){
                                        this.dataAtk = res_Atk.data.result
                                        this.dataAtkExpirse = res_Atk.data.check_date
                                    }else if(res_Atk.status === 204){
                                         this.dataAtk = 'not_found'
                                    }else{
                                        throw { res_Atk }
                                    }
                                } catch (error) {
                                    this.dataAtk = 'not_success'
                                }
                            // ATK PASS
                            // ATK VACCINE
                                try {
                                    const res_Vac = await this.$http.get(`/checkcovid19/vaccine/${res.data[0].staff_id}/check/`)
                                    if(res_Vac.status === 200){
                                        this.datavacineStatus = res_Vac.data.status_detail
                                    }else if(res_Vac.status === 204){
                                        this.datavacineStatus = 'not_found'
                                    }else{
                                        throw { res_Vac }
                                    }
                                } catch (error) {
                                    this.datavacineStatus = 'not_success'
                                }
                            // ATK VACCINE
                            // check blacklist 
                                try {
                                    const resBlock = await this.$http.get(`/checkcovid19/blacklist/${res.data[0].staff_id}/check/`)
                                    if(resBlock.status === 200){
                                        this.dataBlacklist.push(resBlock.data)
                                    }else if(res_Vac.status === 204){
                                        this.dataBlacklist = []
                                    }else{
                                        throw { resBlock }
                                    }
                                } catch (error) {
                                    this.dataBlacklist = []
                                }
                            // check blacklist
                            this.qrHistory = res.data.map(item => {
                                return {
                                    'id': item.id,
                                    'c':  item.staff_id,
                                    'c0': item.staff_name,
                                    'c1': `${item.location_detail.location}`, 
                                    'c5': `${item.location_detail.building}`, 
                                    'c2': this.moment(item.created_at).format('LLL'),
                                    'c4': item.input_type,
                                    'cx': item.location_detail.check_type
                                }
                            })
                            this.BtnCheckPoint = false
                        }
                        else{
                            throw { res }
                        }
                    } catch (error) {
                        if(error.response.status === 401 || error.response.status === 403){
                            this.$router.push({
                                name:"Accpermit",
                                params: { 
                                    ChkText: 'Covid-19 check point',
                                }, 
                            }).catch(err => {})
                        }
                        else{
                            this.$router.push("/notfound").catch(err => {})
                        }
                    } 
                // call api
            },
        },
  };
</script>
